export default __webpack_public_path__ + "static/media/waiver-signees.549bc67e.svg";